import { styled as muiStyle, alpha } from '@mui/material/styles';
import { SelectProps as MuiSelectProps, Select, FormControl, MenuItem } from '@mui/material';
import { ISelectProps } from '../types';
type extendedSelectProps = MuiSelectProps & ISelectProps;

export const StyledSelect = muiStyle(Select)<extendedSelectProps>(({ theme, variant, color, size }: any) => ({
  fontSize: `14px`,
  borderRadius: `2px`,
  '.MuiSelect-select': {
    position: `relative`,
    boxSizing: `border-box`,
    // padding: `10px 20px`,
    zIndex: `1`,
    minHeight: `16px`,
    ...(size === `small` && {
      padding: `0.9px 14px 5.98px 14px`,
      '.MuiSvgIcon-root': { marginRight: `8px` },
    }),

    ...(size === `medium` && {
      padding: `4.9px 14px 9.98px 14px`,
      '.MuiSvgIcon-root': { marginRight: `8px` },
    }),
  },
  '.MuiInputBase-inputSizeSmall': {
    // minHeight: `32px`,
  },
  // '.MuiOutlinedInput-notchedOutline': {
  //     top: 0
  // },
  '&.Mui-error': {
    '.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input': {
      paddingRight: `50px`,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    marginTop: '2px',
    ...(size === `medium` && {
      height: '38px',
    }),
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderWidth: `1px`,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-disabled': {
    color: theme.palette.secondary[400],
    opacity: 1,
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(theme.palette.secondary.light, 0.16),
    },
  },
  '&.Mui-readOnly': {
    color: theme.palette.secondary[400],
    opacity: 1,
    '.MuiOutlinedInput-notchedOutline': {
      backgroundColor: alpha(theme.palette.grayscaleSecondary[50], 0.2),
      borderColor: theme.palette.secondary[300],
    },
  },
}));

export const StyledFormControl = muiStyle(FormControl)(({ theme }) => ({
  '.MuiFormLabel-root': {
    color: theme.palette.secondary[800],
    '&.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '&[data-shrink=false]': {
      top: `-5px`,
    },
    '+ .MuiInputBase-formControl ': {
      '.MuiSelect-select': {
        padding: `9.9px 14px 9.98px 14px`,
      },
    },
  },
}));
export const StyledPlaceholder = muiStyle(MenuItem)(({ theme }) => ({
  color: theme.palette.secondary[400],
}));
